module.exports = __webpack_public_path__ + "static/media/unlock.9f04af37.svg";